import { contact } from "../../components/portfolio"
import './Contact.css'

const Contact = () => {
  if (!contact.email) return null

  return (
    <section className='section contact center' id='contact'>
      <h2 className='section__title'>Contact</h2>
      <a href={`mailto:${contact.email}`} target="_blank">
        <span type='button' className='btn btn--outline'>
          Email me
        </span>
      </a>
      <a href={contact.linkedin} target="_blank">
        <span type='button' className='btn btn--outline' style={{marginTop:"5px", width:"102px"}}>
          Linkedin
        </span>
      </a>
      <a href={contact.github} target="_blank">
        <span type='button' className='btn btn--outline' style={{marginTop:"5px", width:"102px"}}>
          Github
        </span>
      </a>
    </section>
  )
}

export default Contact
